import styled from "styled-components"

const Item = styled.li`
  flex: 0 0 auto;
  padding: 25px 10px;
  width: 100%;

  @media only screen and (min-width: ${props => props.theme.mq.xsmall}) {
    width: calc(100% / 2);
  }

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    padding: 30px 10px;
  }

  @media only screen and (min-width: ${props => props.theme.mq.medium}) {
    width: calc(100% / 3);
  }

  .first-hot & {
    &:first-child {
      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        width: 100%;
      }

      > a {
        @media only screen and (min-width: ${props => props.theme.mq.small}) {
          display: flex;
        }
      }
    }
  }

  > a {
    display: block;
  }
`

const Image = styled.div`
  height: 0;
  overflow: hidden;
  padding-bottom: 56.25%;
  width: 100%;

  ${Item}:first-child & {
    .first-hot & {
      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        flex: 0 0 calc(100% / 3 * 2 - 6px);
        padding-bottom: 36.5%;
        width: calc(100% / 3 * 2 - 6px);
      }
    }
  }

  > div {
    height: 100%;
    transition: transform 1s;

    .no-touchevents a:hover & {
      transform: scale(1.05);
    }
  }
`

const Caption = styled.div`
  padding-top: 17px;

  ${Item}:first-child & {
    .first-hot & {
      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        flex: 0 0 calc(100% / 3 + 7px);
        padding-left: 20px;
        width: calc(100% / 3 + 7px);
      }
    }
  }

  span {
    color: ${props => props.theme.colors.primary};
    display: block;
    font-size: 10px;
    font-weight: ${props => props.theme.title.w};
    letter-spacing: 0.55px;
    margin-bottom: 10px;
    text-transform: uppercase;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 11px;
    }
  }

  h3 {
    font-size: 21px;
    font-weight: ${props => props.theme.title.w};
    line-height: ${props => props.theme.title.lhd};
    margin-bottom: 10px;
    transition: color 0.3s;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 22px;
    }

    .no-touchevents a:hover & {
      color: ${props => props.theme.colors.primary};
    }
  }

  p {
    font-size: ${props => props.theme.text.sm};
    font-weight: ${props => props.theme.text.w};
    line-height: ${props => props.theme.text.lhd};
    margin: 0;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: ${props => props.theme.text.sd};
    }
  }
`

export const sArticle = {
  Item,
  Image,
  Caption,
}
